import { Box, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { parseHTMLDescription } from '../utils/Utils';

type FeaturedResourcesItemProps = {
  name: string;
  imgUrl: string;
  content?: string;
  onItemClicked?: () => void;
};

export const FeaturedResourcesItem = (props: FeaturedResourcesItemProps) => {
  return (
    <Paper
      sx={{
        height: '300px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        borderRadius: 3,
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.73)), url('${props.imgUrl}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        ml: 7.5,
        mr: 7.5,
        pr: 10,
        pl: 10,
        pb: 12.5,
        position: 'relative',
      }}
      onClick={props.onItemClicked}
    >
      <Typography
        variant={'h5'}
        sx={{
          color: 'white',
          fontWeight: 600,
          pt: 2.5,
          px: 2,
        }}
      >
        {props.name}
      </Typography>
      {props.content && (
        <iframe
          style={{
            border: 'none',
            overflow: 'hidden',
          }}
          height='15%'
          width='100%'
          srcDoc={parseHTMLDescription(props.content, 'white', 1)}
          sandbox=''
          scrolling='no'
        />
      )}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          background: 'transparent',
        }}
      />
    </Paper>
  );
};
